module.exports = __webpack_public_path__ + "assets/dafd617a238cdb36d57fffb9969294b9.mp3";